const updateProductData = (ProductData, value, id, key) => {
    ProductData.find((item) => {
        if (item.id === id) {
            item[key] = value; // Update the specified key with the provided value
            return item;
        }
    });
};

export default updateProductData;